"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyTransparencyContentToJSON = exports.SurveyTransparencyContentFromJSONTyped = exports.SurveyTransparencyContentFromJSON = exports.instanceOfSurveyTransparencyContent = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the SurveyTransparencyContent interface.
 */
function instanceOfSurveyTransparencyContent(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfSurveyTransparencyContent = instanceOfSurveyTransparencyContent;
function SurveyTransparencyContentFromJSON(json) {
    return SurveyTransparencyContentFromJSONTyped(json, false);
}
exports.SurveyTransparencyContentFromJSON = SurveyTransparencyContentFromJSON;
function SurveyTransparencyContentFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'transparencyUrl': !(0, runtime_1.exists)(json, 'transparency_url') ? undefined : json['transparency_url'],
        'transparencyLabel': !(0, runtime_1.exists)(json, 'transparency_label') ? undefined : json['transparency_label'],
    };
}
exports.SurveyTransparencyContentFromJSONTyped = SurveyTransparencyContentFromJSONTyped;
function SurveyTransparencyContentToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'transparency_url': value.transparencyUrl,
        'transparency_label': value.transparencyLabel,
    };
}
exports.SurveyTransparencyContentToJSON = SurveyTransparencyContentToJSON;
